<div class="MainContainer">
    <div class="modalContent">
        <div class="d-flex flex-wrap">
            <div class="container">
                <div class="row">
                    <div class="col-sm-5">
                        <div class="leftContent">
                            <app-contents [item]="CurrentItem"></app-contents>
                        </div>
                    </div>
                    <div class="col-sm-7">
                        <div class="formPanel">
                            <div class="title">
                                <h4>Forgot Password</h4>
                                <p>Enter Your email address to get the reset link</p>
                            </div>
                            <div class="contentTab">
                                <div class="form-content">
                                    <!-- Form Section -->
                                    <form [formGroup]="ForgotForm">
                                        <div class="form_log_in_wrap">
                                            <div class="form-group">
                                                <label for="email" class="form_title">Email</label>
                                                <input type="email" formControlName="emailId" class="form-control"
                                                    oninput="this.value = this.value.toLowerCase()" matInput directiveEmail
                                                    (keydown.space)="$event.preventDefault()" maxlength="100"
                                                    [ngClass]="{ 'is-invalid': Submitted && ForgotForm.get('emailId')?.errors }"
                                                    required />
                                                <div *ngIf="Submitted && ForgotForm.get('emailId')?.errors"
                                                    class="invalid-feedback">
                                                    <div *ngIf="ForgotForm.get('emailId')?.errors?.['required']">Email is required</div>
                                                    <div *ngIf="ForgotForm.get('emailId')?.errors?.['invalidEmail']">Please enter a valid email address.</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="sign_up_btn_wrap">
                                            <button (click)="forgotSubmit()" class="btn btn_forgot_psw">
                                                Send Reset Link </button>
                                                <div class="ml-auto"><a class="btn-link"
                                                    [routerLink]="['/home']">Back To Home</a></div>
                                        </div>

                                    </form>
                                    <!-- Form Section Close -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
